import BaseAbility from './base-ability';
import { service } from '@ember/service';
import {
  PREFIX_NETWORK_DNS_FORWARDINGS,
  ACTION_CREATE,
  ACTION_DELETE,
} from '../utils/permission-types/index';
import { TYPE_NETWORK_DNS_FORWARDING_RULE } from 'common/utils/cloud-resource-types';

export default class extends BaseAbility {
  @service abilities;
  @service quota;

  prefix = PREFIX_NETWORK_DNS_FORWARDINGS;

  get canCreate() {
    return (
      this.permissions.has(this.generate(ACTION_CREATE)) &&
      this.model.length < this.quota.for(TYPE_NETWORK_DNS_FORWARDING_RULE)
    );
  }

  get canDelete() {
    const invalidStates = ['CREATING', 'DELETING'];
    return (
      this.permissions.has(this.generate(ACTION_DELETE)) &&
      !invalidStates.includes(this.model.state)
    );
  }
}
